import * as yup from "yup";

export const EarlyPayValidationSchema = yup.object({
  isEarlyPayEnabled: yup.boolean(),
  isDefaultCompanyBankAccountEnabled: yup.boolean(),
});

export type EarlyPayFormType = yup.InferType<typeof EarlyPayValidationSchema>;
